<template>
<div class="icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <g transform="rotate(45 -2.192 29.192)">
        <rect width="14" height="2" y="6" rx="1"/>
        <rect width="14" height="2" y="6" rx="1" transform="rotate(90 7 7)"/>
        </g>
    </svg>
</div>
</template>

<script setup>
</script>